<!-- Side Structure -->
<!-- eslint-disable -->
<template>
  	<div class="sidebar" :class="sidebarSelectedFilter.class">
    	<vue-perfect-scrollbar class="scroll-area" :settings="settings">
        <v-toolbar flat class="transparent scroll-area navigation">
          <v-list style="max-width: 250px;">
				<app-logo></app-logo>
                <user-block v-if="authCheck" :auth="auth" :coronerUserDto="coronerUserDto" :authProfile="authProfile"></user-block>
				<template v-for="(category, key) in menus" v-if="authCheck && isUserSetUp">
					<div :key="key">
						<div class="sidebar-title px-3">
							<span>{{$t(key)}}</span>
						</div>
						<template v-for="item in category" v-if="checkAccess(item.title)">
							<template v-if="item.items != null">
								<v-list-group
									:key="item.title"
									prepend-icon="arrow_right"
									append-icon=""
									no-action
									v-model="item.active"
								>
									<v-list-tile slot="activator">
										<v-list-tile-content>
											<v-list-tile-title>
												<i class="mr-2 zmdi" :class="item.action"></i>
												<span>{{ textTruncate($t(item.title)) }}</span>
											</v-list-tile-title>
										</v-list-tile-content>
									</v-list-tile>
									<v-list-tile 
										v-for="subItem in item.items" 
										v-bind:key="subItem.title" 
										v-if="subItem !== null"
										:to="!subItem.exact ? `/${getCurrentAppLayoutHandler() + subItem.path}` : subItem.path"
									>
										<v-list-tile-content>
											<v-list-tile-title>{{ textTruncate($t(subItem.title)) }}</v-list-tile-title>
										</v-list-tile-content>
									</v-list-tile>
								</v-list-group>
							</template>
							<template v-else>
								<v-list-tile
									:to="!item.exact ? `/${getCurrentAppLayoutHandler() + item.path}` : item.path"
									:key="item.path"
								>
									<v-list-tile-action>
										<!-- <i class="zmdi zmdi-caret-right"></i> -->
                                        <i class="zmdi"></i>
									</v-list-tile-action>
									<v-list-tile-content>
										<v-list-tile-title>
											<i class="mr-2 zmdi" :class="item.action"></i>
											<span>{{ textTruncate($t(item.title)) }}</span>
										</v-list-tile-title>
									</v-list-tile-content>
								</v-list-tile>
							</template>
						</template>
                        <!-- <v-list-tile :to="''" @click="logout">
                            <v-list-tile-action>
                                <i class="zmdi zmdi-power"></i>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    <i class="mr-2 zmdi"></i>
                                    <span>Log Out</span>
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile> -->
					</div>
				</template>
                <template>
                    <div v-if="!authCheck">
                        <v-list-tile :to="''" @click="login">
                            <v-list-tile-action>
                                <i class="zmdi zmdi-sign-in"></i>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    <i class="mr-2 zmdi"></i>
                                    <span>Log In</span>
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </div>
                    <div v-else>
                        <v-list-tile :to="''" @click="logout">
                            <v-list-tile-action>
                                <i class="zmdi zmdi-power"></i>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    <i class="mr-2 zmdi"></i>
                                    <span>Log Out</span>
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </div>
                </template>     
          </v-list>
        </v-toolbar>
    	</vue-perfect-scrollbar>
  	</div>
</template>

<script>
import UserBlock from './UserBlock'
import { textTruncate, getCurrentAppLayout } from '@/helpers/helpers'
import { mapGetters } from 'vuex'
import AppLogo from '@/components/AppLogo/AppLogo'
import userService from '@/services/userService'

export default {
    props: {
        auth: {},
        coronerUserDto: {},
        authProfile: {}
    },
    data () {
        return {
            settings: {
                maxScrollbarLength: 160
            }
        }
    },
    components: {
        UserBlock,
        AppLogo
    },
    computed: {
        ...mapGetters(['sidebarSelectedFilter', 'menus']),
        isAdmin: function () {
            return (this.coronerUserDto && userService.isAdminCountyAdmin(this.coronerUserDto.roleList))
        },
        authCheck: function () {
            return this.auth.authenticated
        },
        isUserSetUp: function () {
            return this.coronerUserDto && this.coronerUserDto.roleList && this.coronerUserDto.roleList.length > 0
        }
    },
    mounted () {
        this.$store.dispatch('setActiveMenuGroup', this.$router)
    },
    methods: {
        textTruncate (text) {
            return textTruncate(text, 18)
        },
        getCurrentAppLayoutHandler () {
            return getCurrentAppLayout(this.$router)
        },
        login () {
            this.auth.login()
        },
        logout () {
            this.auth.logout()
        },
        checkAccess (menuTitle) {
            switch (menuTitle) {
            case 'message.administration':
                return this.isAdmin
            default:
                return true
            }
        }
    }
}
</script>
